import { MAINTENANCE_PAGE_URL } from 'components/App/components/routes';

export const redirectToMaintenance = async () => {
    const currentPathname = window.location.pathname;
    if (currentPathname !== MAINTENANCE_PAGE_URL) {
        window.location.href = MAINTENANCE_PAGE_URL;
    }
};
